var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"flex space-x-4"},_vm._l((_vm.tabs),function(tab){return _c('a',{key:tab.id,class:[
      _vm.currentTab === tab.id
        ? 'bg-gray-200 text-gray-800'
        : 'text-gray-600 hover:text-gray-800',
      'rounded-md px-3 py-2 text-sm font-medium',
    ],attrs:{"href":"#"},on:{"click":function($event){return _vm.onClick(tab)}}},[_vm._v(_vm._s(tab.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }